import React from "react";
import { PageHero, Section, Reveal, Eyebrow, GoldRule } from "@/components/Editorial";
import { Link } from "react-router-dom";

const CATEGORIES = [
  "Mixers", "Juices", "Energy Drinks", "Mineral Water", "Alkaline Water", "Natural Spring Water", "Selected FMCG",
];

export default function NonAlcoPage() {
  return (
    <div data-testid="non-alco-page" className="bg-[#F7F1E7]">
      <PageHero
        eyebrow="Additional Capabilities"
        title="Selected distribution capabilities beyond alcohol."
        lede="Alongside its core alcoholic beverage portfolio, HCC supports selected non-alcoholic beverage and FMCG distribution across Delhi NCR — a deliberately focused, secondary capability."
      />

      <Section tint>
        <Reveal>
          <Eyebrow>Categories</Eyebrow>
          <div className="mt-6 flex flex-wrap gap-3 max-w-3xl" data-testid="non-alco-categories">
            {CATEGORIES.map((c) => (
              <span key={c} className="px-5 py-3 border border-[#1c1713]/20 text-[11px] uppercase tracking-[0.16em] text-[#1c1713]/75">
                {c}
              </span>
            ))}
          </div>
        </Reveal>
      </Section>

      <Section>
        <Reveal className="max-w-2xl">
          <Eyebrow>Distribution Relationships</Eyebrow>
          <p className="mt-5 text-sm font-light leading-relaxed text-[#1c1713]/70">
            Within Delhi NCR, HCC maintains distribution relationships covering products from
            Coca-Cola, Schweppes, Minute Maid, Monster, Evocus, Veen and Whatr. These are
            distribution relationships only; all trademarks remain the property of their respective
            owners.
          </p>
          <p className="mt-4 text-sm font-light leading-relaxed text-[#1c1713]/70">
            The same logistics discipline that serves our alcoholic portfolio — bonded and structured
            warehousing, a company-owned fleet and a permanent logistics team — supports these
            categories across the region.
          </p>
          <GoldRule className="mt-8" />
          <Link
            to="/contact"
            data-testid="non-alco-contact-link"
            className="inline-block mt-6 text-[11px] uppercase tracking-[0.2em] text-[#4B0F1E] border-b border-[#C7A45D] pb-1"
          >
            Discuss NCR distribution →
          </Link>
        </Reveal>
      </Section>
    </div>
  );
}
